<script setup lang="ts">
import { computed } from 'vue'

import { useMainStore } from '@/composables/store'
import { parseSiteConfigData } from '@/utils/siteSeo'

import ProductDetailItemCurrent from './ProductDetailItemCurrent.vue'
import ProductDetailItemLegacy from './ProductDetailItemLegacy.vue'

defineOptions({
  inheritAttrs: false,
})

const store = useMainStore()

const shouldUseCurrentProductDetail = computed(() => {
  const siteInfo = store.getSiteInfo() as any
  const siteConfig = parseSiteConfigData(siteInfo?.configData) as Record<string, any>
  const enabled = siteConfig.showSuccessAppDownloadPopup

  return enabled === true || enabled === 'true' || enabled === 1 || enabled === '1'
})
</script>

<template>
  <ProductDetailItemCurrent
    v-if="shouldUseCurrentProductDetail"
    v-bind="$attrs"
  />
  <ProductDetailItemLegacy
    v-else
    v-bind="$attrs"
  />
</template>
